const BUSINESS_APPROVER_EMAILS = [
  "gowri.m@finlotax.com",
  "rajashree@finlotax.com",
];
const INDIVIDUAL_APPROVER_EMAILS = ["prachi@finlotax.com"];

export function normalizeEmployeeTeam(team) {
  const value = String(team || "").trim().toLowerCase();
  if (value === "business" || value === "individual" || value === "both") {
    return value;
  }
  return "";
}

export function approverEmailsForTeam(team) {
  const key = normalizeEmployeeTeam(team);
  if (key === "business") return [...BUSINESS_APPROVER_EMAILS];
  if (key === "individual") return [...INDIVIDUAL_APPROVER_EMAILS];
  if (key === "both") {
    return [...BUSINESS_APPROVER_EMAILS, ...INDIVIDUAL_APPROVER_EMAILS];
  }
  return [];
}

export function visibleTeamsForEmail(email) {
  const key = String(email || "").trim().toLowerCase();
  if (BUSINESS_APPROVER_EMAILS.includes(key)) return ["business", "both"];
  if (INDIVIDUAL_APPROVER_EMAILS.includes(key)) return ["individual", "both"];
  return [];
}

export function isTeamFirstApprover(email, employeeTeam) {
  const team = normalizeEmployeeTeam(employeeTeam);
  if (!team) return false;
  return visibleTeamsForEmail(email).includes(team);
}
